<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<div class="title-card">
				<h1>
					{{ "ORDER_BASKET.ORDER_SERVICES.ORDER_SERVICE_PAGE_TITLE" | translate }}
				</h1>
				<div class="title-card-details" *ngIf="advertiserName">
					<mat-icon>person</mat-icon>
					<div>{{ advertiserName }}</div>
				</div>
			</div>
			<div class="init-error-container" *ngIf="initErrorMessageKey || initErrorMessage">
				<ng-container *ngIf="initErrorMessageKey">
					{{ initErrorMessageKey | translate }}
				</ng-container>
				<ng-container *ngIf="initErrorMessage">
					{{ initErrorMessage }}
				</ng-container>
			</div>
			<div class="fields-container" *ngIf="!(loading$ | async); else loading">
				<ng-container *ngIf="isReady">
					<mat-form-field>
						<mat-label>{{ "ORDER_BASKET.ORDER_SERVICES.PACKAGE_FIELD_LABEL" | translate }}</mat-label>
						<mat-select [(value)]="selectedPackageId" (selectionChange)="onPackageSelectionChange()">
							<mat-option *ngFor="let packageVM of packagesVMs" [value]="packageVM.id">
								{{ packageVM.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</ng-container>
				<ng-container *ngIf="selectedPackageId">
					<mat-form-field>
						<mat-label>{{ "ORDER_BASKET.ORDER_SERVICES.SERVICE_FIELD_LABEL" | translate }}</mat-label>
						<mat-select [(value)]="selectedServiceId" (selectionChange)="onServiceSelectionChange()">
							<mat-option *ngFor="let serviceVM of servicesVMs" [value]="serviceVM.id">
								{{ serviceVM.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<div>
						<h2>{{ "ORDER_BASKET.ORDER_SERVICES.SELECT_DATES_LABEL" | translate }}</h2>
						<cass-order-select-issues [issueDates]="availableDates" [selectedDates]="selectedDates" (issuesSelected)="selectDates($event)"></cass-order-select-issues>
					</div>
				</ng-container>
			</div>
		</mat-card-content>
	</mat-card>
	<mat-card class='footer branding--action-card button-container'>
		<mat-card-content>
			<button mat-raised-button color='primary' (click)="applyAction()" [disabled]="!canApply">{{ "ACTION_BUTTON_LABELS.APPLY" | translate }}</button>
			<button mat-stroked-button (click)="cancelAction()" *ngIf="!isModified">{{ "ACTION_BUTTON_LABELS.CANCEL" | translate }}</button>
			<button mat-stroked-button (click)="cancelAction()" *ngIf="isModified">{{ "ACTION_BUTTON_LABELS.DISCARD_CHANGES" | translate }}</button>
		</mat-card-content>
	</mat-card>
</div>
<ng-template #loading>
	<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
</ng-template>
